<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>中央八项规定精神学习专题</h2>
        <p style="text-align: right"><span
            style="margin-right: 60px">2025-03-13</span></p>
        <p>
          党的二十届三中全会审议通过的《中共中央关于进一步全面深化改革、推进中国式现代化的决定》明确提出“锲而不舍落实中央八项规定精神，健全防治形式主义、官僚主义制度机制”。为进一步深入学习习近平总书记关于中央八项规定的重要讲话精神，引导广大党员干部强化纪律规矩意识，本期推出《中央八项规定精神》专题学习。
        </p>
        <div class="center">一、什么是中央八项规定？</div>
        <p>
          2012年12月4日，中共中央政治局召开会议，审议通过了《中央政治局关于改进工作作风、密切联系群众的八项规定》，因为其主要内容有八项，所以简称为中央八项规定。其内容包括：改进调查研究、精简会议活动、精简文件简报、规范出访活动、改进警卫工作、改进新闻报道、严格文稿发表、厉行勤俭节约等8个方面。
        </p>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <p>
          1.要改进调查研究，到基层调研要深入了解真实情况，总结经验、研究问题、解决困难、指导工作，向群众学习、向实践学习，多同群众座谈，多同干部谈心，多商量讨论，多解剖典型。
        </p>
        <p>
          2.要精简会议活动，切实改进会风，严格控制以中央名义召开的各类全国性会议和举行的重大活动，不开泛泛部署工作和提要求的会，未经中央批准一律不出席各类剪彩、奠基活动和庆祝会、纪念会、表彰会、博览会、研讨会及各类论坛；提高会议实效，开短会、讲短话，力戒空话、套话。
        </p>
        <p>3.要精简文件简报，切实改进文风，没有实质内容、可发可不发的文件、简报一律不发。</p>
        <p>
          4.要规范出访活动，从外交工作大局需要出发合理安排出访活动，严格控制出访随行人员，严格按照规定乘坐交通工具，一般不安排中资机构、华侨华人、留学生代表等到机场迎送。
        </p>
        <p>5.要改进警卫工作，坚持有利于联系群众的原则，减少交通管制，一般情况下不得封路、不清场闭馆。</p>
        <p>6.要改进新闻报道，出席会议和活动应根据工作需要、新闻价值、社会效果决定是否报道，进一步压缩报道的数量、字数、时长。</p>
        <p>7.要严格文稿发表，除中央统一安排外，个人不公开出版著作、讲话单行本，不发贺信、贺电，不题词、题字。</p>
        <p>8.要厉行勤俭节约，严格遵守廉洁从政有关规定，严格执行住房、车辆配备等有关工作和生活待遇的规定。</p>
        <div class="center">二、什么是中央八项规定精神？</div>
        <p>
          中央八项规定出台以后，在全国范围内具有导向作用，各级党组织向中央树立的标杆看齐。根据中央八项规定，各地各部门也制定了自己的具体规定，这些规定均属于落实中央八项规定精神的细则。
        </p>
        <p>
          中央八项规定精神实质是：厉行勤俭节约、反对奢侈浪费和奢靡之风、廉洁从政、工作作风务实等，与此相违背的，就是违反了中央八项规定精神。因此，“违反中央八项规定精神问题”是指违反“中央八项规定精神”所列类型之问题的违纪行为，即“四风”（形式主义、官僚主义、享乐主义、奢靡之风）方面的违纪行为。对广大党员而言，违反的不是中央八项规定，而是中央八项规定精神。
        </p>
        <p class="blue01">违反中央八项规定精神问题第一大类是形式主义、官僚主义（4大类表现）：</p>
        <p>1.贯彻党中央重大决策部署有令不行、有禁不止，或者表态多调门高、行动少落实差，脱离实际、脱离群众，造成严重后果；</p>
        <p>2.在履职尽责、服务经济社会发展和生态环境保护方面不担当、不作为、乱作为、假作为，严重影响高质量发展；</p>
        <p>3.在联系服务群众中消极应付、冷硬横推、效率低下，损害群众利益，群众反映强烈；</p>
        <p>4.文山会海反弹回潮，文风会风不实不正，督查检查考核过多过频、过度留痕，给基层造成严重负担；</p>
        <p class="blue01">违反中央八项规定精神问题第二大类是享乐主义、奢靡之风（6大类14种表现）：</p>
        <p>1. 违规收送名贵特产和礼品礼金（包括2种表现：违规收送名贵特产类礼品、违规收送礼金和其他礼品）；</p>
        <p>2. 违规吃喝（包括2种表现：违规公款吃喝、违规接受管理和服务对象等宴请）</p>
        <p>3.违规操办享乐主义、奢靡之风婚丧喜庆；</p>
        <p>4. 违规发放津补贴或福利；</p>
        <p>5. 公款旅游以及违规接受管理和服务对象等旅游活动安排；</p>
        <p>
          6.其他（包括6种表现：违规配备和使用公车、楼堂馆所问题、提供或接受超标准接待、组织或参加用公款支付的高消费娱乐健身等活动、接受或提供可能影响公正执行公务的健身娱乐等活动、违规出入私人会所、领导干部住房违规）。
        </p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span style="cursor: pointer; color: #666; font-size: 14px">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <!-- &lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》... -->
          </span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build9' })"
          >总书记在三中全会上的重要讲话发表...&nbsp;&nbsp;&nbsp;&nbsp;下一条
            &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/build1.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.center {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }

  .blue01 {
    font-weight: bold;
    color: #000080;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>